<template>
  <div>
    <v-row justify="center">
      <v-col cols="11">
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form v-model="valid">
              <v-container>
                <v-row>
                  <!--Nombre-->
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="editedItem.firstName"
                      outlined
                      placeholder=" "
                      background-color="white"
                      dense
                      @keypress="isLetter($event)"
                      :rules="[(v) => !!v || 'Campo requerido']"
                      label="Nombre*"
                    >
                    </v-text-field>
                  </v-col>

                  <!--Apellido-->
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="editedItem.lastName"
                      outlined
                      placeholder=" "
                      background-color="white"
                      dense
                      @keypress="isLetter($event)"
                      :rules="[(v) => !!v || 'Campo requerido']"
                      label="Apellido*"
                    >
                    </v-text-field>
                  </v-col>

                  <!--Mail-->
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="editedItem.email"
                      outlined
                      placeholder=" "
                      background-color="white"
                      dense
                      @keypress="validateEmail"
                      :rules="[
                        (v) => !!v || 'Campo requerido',
                        (v) =>
                          /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
                          'Debe ser un correo electrónico válido',
                      ]"
                      label="Correo*"
                    >
                    </v-text-field>
                  </v-col>

                  <!--Telefono-->
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="editedItem.phone"
                      outlined
                      placeholder=" "
                      background-color="white"
                      dense
                      onkeypress="
                        return event.charCode >= 48 && event.charCode <= 57;
                      "
                      :maxlength="10"
                      :counter="10"
                      :rules="telephoneRules"
                      label="Telefono*"
                    >
                    </v-text-field>
                  </v-col>

                  <!--Empresa-->
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="editedItem.company"
                      outlined
                      placeholder=" "
                      background-color="white"
                      dense
                      @keypress="validateCompany"
                      :rules="[(v) => !!v || 'Campo requerido']"
                      label="Empresa*"
                    >
                    </v-text-field>
                  </v-col>

                  <!--Estado-->
                  <v-col cols="12" sm="12" md="6">
                    <v-select
                      v-model="editedItem.stateId"
                      :items="states"
                      label="Estado*"
                      :menu-props="{
                        auto: true,
                        overflowY: true,
                        height: '200',
                      }"
                      outlined
                      dense
                      item-value="id"
                      item-text="name"
                    >
                    </v-select>
                  </v-col>

                  <!--Departamento-->
                  <v-col cols="12" sm="12" md="6">
                    <v-select
                      v-model="editedItem.departmentId"
                      :items="departments"
                      label="Departamento*"
                      outlined
                      dense
                      item-value="id"
                      item-text="name"
                    >
                    </v-select>
                  </v-col>

                  <!--Puesto-->
                  <v-col cols="12" sm="12" md="6">
                    <v-select
                      v-model="editedItem.positionId"
                      :items="positions"
                      label="Puesto*"
                      outlined
                      dense
                      item-value="id"
                      item-text="name"
                    >
                    </v-select>
                  </v-col>

                  <!--Giro-->
                  <v-col cols="12" sm="12" md="6">
                    <v-select
                      v-model="editedItem.sectorId"
                      :items="sectors"
                      label="Giro*"
                      outlined
                      dense
                      item-value="id"
                      item-text="name"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <p>* Campos Obligatorios</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="blue darken-1" text @click="returnLogin">
              Cancelar
            </v-btn>

            <v-btn
              color="blue darken-1"
              text
              :disabled="!valid"
              :loading="saving"
              @click="save"
            >
              Registrarme
            </v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "underscore";
import { events } from "./../../main";

export default {
  name: "register",

  components: {},

  data() {
    return {
      telephoneRules: [
        (v) => !!v || "Campo requerido",
        (v) => (v && v.length == 10) || "El telefono debe tener 10 caracteres.",
      ],
      departments: [],
      positions: [],
      sectors: [],
      clients: [],
      states: [],
      users: [],
      valid: false,
      saving: false,
      dialog: false,
      confirmDialog: false,
      editedIndex: -1,
      editedItem: {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        clientId: "",
        roleId: "",
        stateId: "",
        departmentId: "",
        sectorId: "",
        positionId: "",
      },
      defaultItem: {
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        company: "",
        clientId: "",
        roleId: "",
        stateId: "",
        departmentId: "",
        sectorId: "",
        positionId: "",
      },
      userId: "",
      fromCatalog: this.$route.params.from_catalog ? true : false,
    };
  },

  props: {
    showRegister: { type: Boolean },
    sendSnack: { type: Function },
  },

  methods: {
    initialize() {
      this.$http.get(`state`).then(
        (response) => {
          var list = response.body.data;
          this.states = _.sortBy(list, (x) => {
            return x.name;
          });
          this.loading = false;
        },
        (error) => {
          this.sendSnack(
            error.message || "Hubo un problema al obtener la lista de Estados"
          );
          console.error(error);
        }
      );
      this.$http.get(`department`).then(
        (response) => {
          var list = response.body.data;
          this.departments = list;
          this.loading = false;
        },
        (error) => {
          this.sendSnack(
            error.message ||
              "Hubo un problema al obtener la lista de departamentos"
          );
          console.error(error);
        }
      );
      this.$http.get(`position`).then(
        (response) => {
          var list = response.body.data;
          this.positions = list;
          this.loading = false;
        },
        (error) => {
          this.sendSnack(
            error.message ||
              "Hubo un problema al obtener la lista de departamentos"
          );
          console.error(error);
        }
      );
      this.$http.get(`sector`).then(
        (response) => {
          var list = response.body.data;
          this.sectors = list;
          this.loading = false;
        },
        (error) => {
          this.sendSnack(
            error.message ||
              "Hubo un problema al obtener la lista de departamentos"
          );
          console.error(error);
        }
      );
    },

    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g.test(char))
        return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },

    validateEmail(e) {
      let char = String.fromCharCode(e.keyCode);
      const validChars = /^[a-zA-Z0-9@._-]+$/;
      if (validChars.test(char)) {
        return true;
      } else {
        e.preventDefault();
      }
    },

    validateCompany(e) {
      let char = String.fromCharCode(e.keyCode); // Obtener el carácter
      if (/^[a-zA-ZÀ-ÿ\u00f1\u00d1.\s0-9]*$/g.test(char)) {
        return true; // Coincide con la expresión regular
      } else {
        e.preventDefault(); // Si no coincide, evitar la entrada en el campo de texto
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.$http.post("user/register", this.editedItem).then(
        (response) => {
          this.users.push(this.editedItem);
          this.sendSnack(
            response.body.message ||
              "Has sido registrado con éxito, inicia sesión con la contraseña enviada al correo electrónico registrado."
          );
          this.saving = false;
          this.returnLogin();
          this.userId = "";
        },
        (error) => {
          console.log(error);
          var message =
            error.body.error.code == "ELEMENT_NOT_UNIQUE"
              ? "El correo electronico ya existe en el sistema"
              : "Error al crear registro";
          this.sendSnack(message);
          this.saving = false;
          this.userId = "";
        }
      );
    },

    snackbar(message) {
      events.$emit("snackbar", message);
    },

    returnLogin: function () {
      this.$emit("backToLogin");
    },
  },

  computed: {
    formTitle() {
      return "Registro";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created: function () {
    this.initialize();
  },

  mounted() {},
};
</script>

<style lang="stylus" scoped></style>
